import React from 'react'
import { useQuery } from '@tanstack/react-query'

import { get, queryKeys } from '@mobi/account/Utils'
import { PageStyled } from '@mobi/account/Common/Styles'
import { Spinner } from '@mobi/component-library/Legacy/Spinner'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'

import { type PrecommitmentResponse } from '../BetLimit/BetLimitPage'
import { precommitmentUrl } from '@mobi/account/Utils'
import { BankCardBlock } from './BankCardBlock'

export const BlockDebitCardPage: React.FC = () => {
  const { isLoading, isError, data } = useQuery<PrecommitmentResponse>({
    queryKey: queryKeys.precommitmentDetails,
    queryFn: () => get(precommitmentUrl.precommitmentDetails),
    retry: false,
    refetchOnWindowFocus: false,
  })

  return (
    <>
      <PageHeader title='Block Debit Card' />
      <PageStyled data-testid='block-debit-card' id='credit-card-block'>
        {isLoading ? <Spinner /> : <BankCardBlock data={data} hasDataFetchFailed={isError} />}
      </PageStyled>
    </>
  )
}
